import * as actions from "../actions";
import produce from "immer";
import _ from "underscore";
import * as depositActions from "../../orders/actions";
import { PREPARE_FOR_NEW_TRANSFER } from "../actions";

export const initialState = {
  depositPayments: {
    fetching: false,
    fetched: false,
    sent: false,
    sending: false,
    data: [],
  },

  investorDepositsToTransfer: {
    fetching: false,
    fetched: false,
    data: [],
    dataNonTransferable: [],
    dataAml: [],
  },

  depotsSuggestedForDepositTransfer: {
    fetching: false,
    fetched: false,
    data: [],
  },

  invoicePayments: {
    fetching: false,
    fetched: false,
    sent: false,
    sending: false,
    data: [],
  },

  lastSentInvoicePaymentData: {
    error: null,
    notDistributableReason: null,
    paymentId: null,
    sent: false,
  },

  matchedDeposits: {
    fetching: false,
    fetched: false,
    data: {},
    manualMatchData: {},
  },

  matchedInvoices: {
    fetching: false,
    fetched: false,
    data: [],
    allTransferred: {
      totalAmount: 0,
      plannedNumberToDo: 0,
      numberOfDone: 0,
    },
  },
};

export function accountingOrdersSubReducer(state, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case PREPARE_FOR_NEW_TRANSFER:
        draft.matchedInvoices.allTransferred.plannedNumberToDo =
          action.additionalData.plannedNumberToDo;
        draft.matchedInvoices.allTransferred.numberOfDone = 0;
        draft.matchedInvoices.allTransferred.totalAmount = 0;
        break;

      case actions.INVESTOR_DEPOSITS_TO_TRANSFER_FETCH_SUCCESS: {
        const data = action.response.filter((item) => {
          return item.CanBeTransferred;
        });
        const dataAml = action.response.filter((item) => {
          return item.AmlWarning === true;
        });
        const dataNonTransferable = action.response.filter((item) => {
          return item.CanBeTransferred === false;
        });

        draft.investorDepositsToTransfer.data = data;
        draft.investorDepositsToTransfer.dataAml = dataAml;
        draft.investorDepositsToTransfer.dataNonTransferable =
          dataNonTransferable;
        draft.investorDepositsToTransfer.fetched = true;
        draft.investorDepositsToTransfer.fetching = false;
        break;
      }
      case actions.INVESTOR_DEPOSIT_TRANSFER_SUCCESS: {
        let id = action.dataSent.investorDepositId;
        let data = _.filter(state.investorDepositsToTransfer.data, (item) => {
          return item.Id !== id;
        });

        draft.investorDepositsToTransfer.data = data;
        break;
      }
      case actions.INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_SUCCESS: {
        const id = action.InvestorDepositId;
        const depotId = action.DepotId;
        const index = _.findIndex(
          state.investorDepositsToTransfer.data,
          (item) => {
            return item.InvestorDepositId === id;
          },
        );
        draft.investorDepositsToTransfer.data[index].DepotId = depotId;
        draft.investorDepositsToTransfer.data[index].InvestorName =
          action.response.Name;
        draft.investorDepositsToTransfer.data[index].IsBolded = true;
        break;
      }
      case actions.INVESTOR_DEPOSIT_TRANSFER_DEPOT_ID_OVERRIDE_ERROR: {
        const id = action.InvestorDepositId;
        const index = _.findIndex(
          state.investorDepositsToTransfer.data,
          (item) => {
            return item.InvestorDepositId === id;
          },
        );
        draft.investorDepositsToTransfer.data[index].Error =
          "ERROR WHILE FETCHING DEPOT";
        break;
      }
      // Old flow + invoice orders
      case actions.DEPOSIT_PAYMENTS_SUCCESS:
        draft.depositPayments.data = action.response;
        break;
      case actions.DEPOSIT_MATCH_SUCCESS:
        draft.matchedDeposits.data = {
          ...draft.matchedDeposits.data,
          ...action.response,
        };
        break;
      case actions.MANUAL_DEPOSIT_MATCH_SUCCESS:
        draft.matchedDeposits.data = {
          ...draft.matchedDeposits.data,
          ...action.response,
        };
        draft.matchedDeposits.manualMatchData = {
          ...draft.matchedDeposits.manualMatchData,
          ...action.response,
        };
        break;
      case depositActions.APPROVE_DEPOSIT_ORDER_SUCCESS:
        //After approval of deposit succeeded we need to remove payment and match from reducer
        var depositPaymentToRemoveIndex = _.findIndex(
          state.depositPayments.data,
          (payment) => {
            return payment.Id === action.dataSent.PaymentId;
          },
        );
        draft.depositPayments.data = [
          ...draft.depositPayments.data.slice(0, depositPaymentToRemoveIndex),
          ...draft.depositPayments.data.slice(depositPaymentToRemoveIndex + 1),
        ];
        break;
      case actions.INVOICE_PAYMENTS_SUCCESS:
        draft.invoicePayments.data = action.response;
        break;
      case actions.MATCHED_INVOICE_PAYMENTS_SUCCESS:
        draft.matchedInvoices.data = action.response;
        break;
      // REGISTERING PAYMENTS ACTIONS
      case actions.REGISTER_INVOICE_PAYMENT_SUCCESS:
        draft.invoicePayments.data = [
          ...draft.invoicePayments.data,
          {
            Id: action.response.RepaymentId,
            RefCode: action.dataSent.RefCode,
            Amount: { Amount: action.dataSent.Amount },
          },
        ];
        draft.invoicePayments.sending = false;
        draft.invoicePayments.sent = true;
        draft.lastSentInvoicePaymentData.error = null;
        draft.lastSentInvoicePaymentData.notDistributableReason =
          action.response.NotDistributableReason;
        draft.lastSentInvoicePaymentData.paymentId = action.dataSent.PaymentId;
        draft.lastSentInvoicePaymentData.sent = true;
        break;
      case actions.REGISTER_INVOICE_PAYMENT_ERROR:
        draft.invoicePayments.sending = false;
        draft.invoicePayments.sent = true;
        draft.invoicePayments.sendError = action.error;
        draft.lastSentInvoicePaymentData.error = action.error;
        draft.lastSentInvoicePaymentData.notDistributableReason = null;
        draft.lastSentInvoicePaymentData.paymentId = action.dataSent.PaymentId;
        draft.lastSentInvoicePaymentData.sent = true;
        break;
      case actions.REGISTER_DEPOSIT_PAYMENT_SUCCESS:
        draft.depositPayments.data = [
          ...draft.depositPayments.data,
          {
            Id: "NA",
            RefCode: action.dataSent.RefCode,
            Amount: { Amount: action.dataSent.Amount },
          },
        ];
        draft.depositPayments.sending = false;
        draft.depositPayments.sent = true;
        break;
      case actions.REGISTER_DEPOSIT_PAYMENT_REQUEST:
        draft.depositPayments.sending = true;
        draft.depositPayments.sent = false;
        break;
      case actions.REGISTER_INVOICE_PAYMENT_REQUEST:
        draft.invoicePayments.sending = true;
        draft.invoicePayments.sent = false;
        draft.invoicePayments.sendError = undefined;
        draft.lastSentInvoicePaymentData.error = null;
        draft.lastSentInvoicePaymentData.notDistributableReason = null;
        draft.lastSentInvoicePaymentData.paymentId = null;
        draft.lastSentInvoicePaymentData.sent = false;
        break;
      case actions.TRANSFER_INVOICE_PAYMENT_SUCCESS: {
        //Remove invoice payment after
        // succeeded
        const invoicePaymentToRemoveIndex = _.findIndex(
          state.invoicePayments.data,
          (payment) => {
            return payment.Id === action.dataSent.PaymentId;
          },
        );

        const matchedInvoicePaymentToRemoveIndex = _.findIndex(
          state.matchedInvoices.data,
          (payment) => {
            return payment.Id === action.dataSent.PaymentId;
          },
        );
        draft.invoicePayments.data =
          invoicePaymentToRemoveIndex !== -1
            ? [
                ...draft.invoicePayments.data.slice(
                  0,
                  invoicePaymentToRemoveIndex,
                ),
                ...draft.invoicePayments.data.slice(
                  invoicePaymentToRemoveIndex + 1,
                ),
              ]
            : [...draft.invoicePayments.data];
        draft.matchedInvoices.data =
          matchedInvoicePaymentToRemoveIndex !== -1
            ? [
                ...draft.matchedInvoices.data.slice(
                  0,
                  matchedInvoicePaymentToRemoveIndex,
                ),
                ...draft.matchedInvoices.data.slice(
                  matchedInvoicePaymentToRemoveIndex + 1,
                ),
              ]
            : [...draft.matchedInvoices.data];

        draft.matchedInvoices.allTransferred.totalAmount +=
          action.additionalData.partAmount;
        draft.matchedInvoices.allTransferred.numberOfDone += 1;
        break;
      }

      // Change flag that will include or remove payment from sending loop
      case actions.CHANGE_PAYMENT_SEND_FLAG:
        if (action.paymentType === "invoice") {
          var invoicePaymentSendingChangeIndex = _.findIndex(
            state.matchedInvoices.data,
            (payment) => {
              return payment.Id === action.id;
            },
          );

          var invoiceToChange =
            state.matchedInvoices.data[invoicePaymentSendingChangeIndex];
          invoiceToChange.RemoveFromSending =
            !invoiceToChange.RemoveFromSending;

          draft.matchedInvoices.data =
            invoicePaymentSendingChangeIndex !== -1
              ? [
                  ...draft.matchedInvoices.data.slice(
                    0,
                    invoicePaymentSendingChangeIndex,
                  ),
                  invoiceToChange,
                  ...draft.matchedInvoices.data.slice(
                    invoicePaymentSendingChangeIndex + 1,
                  ),
                ]
              : [...draft.matchedInvoices.data];
          break;
        } else {
          var depositToChange = state.matchedDeposits.data[action.id];
          depositToChange.RemoveFromSending =
            !depositToChange.RemoveFromSending;
          draft.matchedDeposits.data = state.matchedDeposits.data;
          break;
        }
      default:
        return draft;
    }
  });
}
